import type { EstadoBrasil } from "../types";

export const CARGOS_PUBLICOS = {
  DEPUTADO_FEDERAL: 46366.19,
  MAGISTRADO_ESTADUAL: 37563.36  
} as const;

// Salários medianos de magistrados estaduais por UF (CNJ 2024)
export const MAGISTRADOS_POR_ESTADO = {
  "AC": 37563,
  "AL": 37563,
  "AP": 37563,
  "AM": 37563,
  "BA": 36608,
  "CE": 37563,
  "DF": 37563,
  "ES": 37563,
  "GO": 37563,
  "MA": 37563,
  "MT": 37563,
  "MS": 37563,
  "MG": 37406,
  "PA": 35685,
  "PB": 37563,
  "PR": 37548,
  "PE": 37563,
  "PI": 37563,
  "RJ": 37563,
  "RN": 37563,
  "RS": 35586,
  "RO": 37563,
  "RR": 37563,
  "SC": 37563,
  "SP": 37563,
  "SE": 37563,
  "TO": 40917
} as const;

export const RENTABILIDADE_INVESTIMENTO = 0.08; 

export const ESTADOS_BRASIL: readonly EstadoBrasil[] = [
  { value: "AC", label: "Acre", regiao: "NORTE" },
  { value: "AL", label: "Alagoas", regiao: "NORDESTE" },
  { value: "AP", label: "Amapá", regiao: "NORTE" },
  { value: "AM", label: "Amazonas", regiao: "NORTE" },
  { value: "BA", label: "Bahia", regiao: "NORDESTE" },
  { value: "CE", label: "Ceará", regiao: "NORDESTE" },
  { value: "DF", label: "Distrito Federal", regiao: "CENTRO_OESTE" },
  { value: "ES", label: "Espírito Santo", regiao: "SUDESTE" },
  { value: "GO", label: "Goiás", regiao: "CENTRO_OESTE" },
  { value: "MA", label: "Maranhão", regiao: "NORDESTE" },
  { value: "MT", label: "Mato Grosso", regiao: "CENTRO_OESTE" },
  { value: "MS", label: "Mato Grosso do Sul", regiao: "CENTRO_OESTE" },
  { value: "MG", label: "Minas Gerais", regiao: "SUDESTE" },
  { value: "PA", label: "Pará", regiao: "NORTE" },
  { value: "PB", label: "Paraíba", regiao: "NORDESTE" },
  { value: "PR", label: "Paraná", regiao: "SUL" },
  { value: "PE", label: "Pernambuco", regiao: "NORDESTE" },
  { value: "PI", label: "Piauí", regiao: "NORDESTE" },
  { value: "RJ", label: "Rio de Janeiro", regiao: "SUDESTE" },
  { value: "RN", label: "Rio Grande do Norte", regiao: "NORDESTE" },
  { value: "RS", label: "Rio Grande do Sul", regiao: "SUL" },
  { value: "RO", label: "Rondônia", regiao: "NORTE" },
  { value: "RR", label: "Roraima", regiao: "NORTE" },
  { value: "SC", label: "Santa Catarina", regiao: "SUL" },
  { value: "SP", label: "São Paulo", regiao: "SUDESTE" },
  { value: "SE", label: "Sergipe", regiao: "NORDESTE" },
  { value: "TO", label: "Tocantins", regiao: "NORTE" }
] as const;

export const REGIOES_BRASIL = {
  NORTE: ["AC", "AP", "AM", "PA", "RO", "RR", "TO"],
  NORDESTE: ["AL", "BA", "CE", "MA", "PB", "PE", "PI", "RN", "SE"],
  SUDESTE: ["ES", "MG", "RJ", "SP"],
  SUL: ["PR", "RS", "SC"],
  CENTRO_OESTE: ["DF", "GO", "MS", "MT"]
} as const;

export const DISTRIBUICAO_PERCENTIL_NACIONAL = {
  6: 500,     // Teste exato
  11: 900,    // Derivado 
  14: 1000,   // Teste exato  
  17: 1400,   // Derivado
  22: 1500,   // Teste exato
  25: 1650,   // Interpolado
  30: 1800,   // Interpolado
  40: 1950,   // Interpolado
  52: 2000,   // Teste exato
  60: 2400,   // Interpolado
  62: 2500,   // Teste exato
  70: 2800,   // Interpolado
  72: 3000,   // Teste exato
  76: 3500,   // Teste exato
  81: 4000,   // Teste exato
  82: 4500,   // Teste exato
  87: 5000,   // Teste exato
  88: 5500,   // Teste exato
  90: 6000,   // Teste exato
  91: 7000,   // Teste exato
  92: 7500,   // Teste exato
  93: 8000,   // Teste exato
  94: 9000,   // Teste exato
  95: 10000,  // Teste exato
  96: 11000,  // Teste exato
  99: 15000   // Estimado
} as const;

// DISTRIBUIÇÕES ESTADUAIS 
export const DISTRIBUICAO_POR_ESTADO = {
  // ACRE - R$ 1000=20%, R$ 2000=65%, R$ 3500=81%, R$ 6000=92%, R$ 10000=97%
  "AC": {
    5: 600, 10: 800, 20: 1000, 30: 1200, 40: 1400,
    50: 1600, 60: 1800, 65: 2000, 70: 2200, 80: 3200,
    81: 3500, 90: 5500, 92: 6000, 95: 8500, 97: 10000, 99: 15000
  },

  // ALAGOAS - R$ 1000=22%, R$ 2000=74%, R$ 3500=87%, R$ 6000=94%, R$ 10000=97%
  "AL": {
    5: 550, 10: 750, 22: 1000, 30: 1150, 40: 1300,
    50: 1450, 60: 1600, 70: 1850, 74: 2000, 80: 2500,
    87: 3500, 90: 4200, 94: 6000, 95: 6500, 97: 10000, 99: 15000
  },

  // AMAPÁ - R$ 1000=15%, R$ 2000=61%, R$ 3500=79%, R$ 6000=92%, R$ 10000=96%
  "AP": {
    5: 650, 10: 850, 15: 1000, 30: 1300, 40: 1500,
    50: 1700, 60: 1950, 61: 2000, 70: 2400, 79: 3500,
    80: 3700, 90: 5400, 92: 6000, 95: 8000, 96: 10000, 99: 14000
  },

  // AMAZONAS - R$ 1000=25%, R$ 2000=65%, R$ 3500=84%, R$ 6000=94%, R$ 10000=97%
  "AM": {
    5: 500, 10: 700, 20: 900, 25: 1000, 40: 1300,
    50: 1500, 60: 1750, 65: 2000, 70: 2200, 80: 2800,
    84: 3500, 90: 4500, 94: 6000, 95: 6500, 97: 10000, 99: 15000
  },

  // BAHIA - R$ 1000=29%, R$ 2000=73%, R$ 3500=87%, R$ 6000=95%, R$ 10000=98%
  "BA": {
    5: 450, 10: 650, 20: 800, 29: 1000, 40: 1200,
    50: 1400, 60: 1600, 70: 1850, 73: 2000, 80: 2500,
    87: 3500, 90: 4200, 95: 6000, 98: 10000, 99: 12000
  },

  // CEARÁ - R$ 1000=30%, R$ 2000=74%, R$ 3500=88%, R$ 6000=95%, R$ 10000=98%
  "CE": {
    5: 440, 10: 630, 20: 790, 30: 1000, 40: 1180,
    50: 1380, 60: 1580, 70: 1800, 74: 2000, 80: 2400,
    88: 3500, 90: 4000, 95: 6000, 98: 10000, 99: 12000
  },

  // DISTRITO FEDERAL - R$ 900=6%, R$ 1000=7%, R$ 2000=40%, R$ 3500=62%, R$ 6000=76%, R$ 10000=87%
  "DF": {
    5: 850, 6: 900, 7: 1000, 10: 1200, 20: 1600, 30: 1800,
    40: 2000, 50: 2400, 60: 2800, 62: 3500, 70: 4500,
    76: 6000, 80: 7000, 87: 10000, 90: 12000, 95: 18000, 99: 30000
  },

  // ESPÍRITO SANTO - R$ 1000=10%, R$ 2000=50%, R$ 3500=77%, R$ 6000=90%, R$ 10000=95%
  "ES": {
    5: 700, 10: 1000, 20: 1300, 30: 1600, 40: 1800,
    50: 2000, 60: 2200, 70: 2600, 77: 3500, 80: 4000,
    90: 6000, 95: 10000, 99: 16000
  },

  // GOIÁS - R$ 1000=8%, R$ 2000=49%, R$ 3500=76%, R$ 6000=91%, R$ 10000=96%
  "GO": {
    5: 750, 8: 1000, 10: 1100, 20: 1400, 30: 1650,
    40: 1850, 49: 2000, 50: 2050, 60: 2300, 70: 2700,
    76: 3500, 80: 4000, 90: 5800, 91: 6000, 95: 8500, 96: 10000, 99: 14000
  },

  // MARANHÃO - R$ 1000=33%, R$ 2000=74%, R$ 3500=88%, R$ 6000=96%, R$ 10000=98%
  "MA": {
    5: 400, 10: 580, 20: 720, 30: 900, 33: 1000,
    40: 1100, 50: 1250, 60: 1420, 70: 1650, 74: 2000,
    80: 2300, 88: 3500, 90: 4000, 95: 5500, 96: 6000, 98: 10000, 99: 12000
  },

  // MATO GROSSO DO SUL - R$ 1000=8%, R$ 2000=44%, R$ 3500=72%, R$ 6000=88%, R$ 10000=95%
  "MS": {
    5: 750, 8: 1000, 10: 1120, 20: 1450, 30: 1700,
    40: 1900, 44: 2000, 50: 2150, 60: 2400, 70: 2800,
    72: 3500, 80: 4200, 88: 6000, 90: 7000, 95: 10000, 99: 15000
  },

  // MATO GROSSO - R$ 1000=7%, R$ 2000=42%, R$ 3500=72%, R$ 6000=89%, R$ 10000=96%
  "MT": {
    5: 800, 7: 1000, 10: 1150, 20: 1500, 30: 1750,
    40: 1950, 42: 2000, 50: 2200, 60: 2500, 70: 2900,
    72: 3500, 80: 4300, 89: 6000, 90: 6200, 95: 9000, 96: 10000, 99: 14000
  },

  // MINAS GERAIS - R$ 1000=11%, R$ 2000=54%, R$ 3500=79%, R$ 6000=92%, R$ 10000=97%
  "MG": {
    5: 600, 10: 950, 11: 1000, 20: 1250, 30: 1500,
    40: 1700, 50: 1900, 54: 2000, 60: 2150, 70: 2500,
    79: 3500, 80: 3650, 90: 5500, 92: 6000, 95: 8000, 97: 10000, 99: 14000
  },

  // PARÁ - R$ 1000=30%, R$ 2000=69%, R$ 3500=85%, R$ 6000=94%, R$ 10000=97%
  "PA": {
    5: 450, 10: 650, 20: 800, 30: 1000, 40: 1200,
    50: 1400, 60: 1650, 69: 2000, 70: 2050, 80: 2600,
    85: 3500, 90: 4400, 94: 6000, 95: 6500, 97: 10000, 99: 14000
  },

  // PARAÍBA - R$ 1000=30%, R$ 2000=75%, R$ 3500=87%, R$ 6000=94%, R$ 10000=97%
  "PB": {
    5: 450, 10: 650, 20: 800, 30: 1000, 40: 1150,
    50: 1350, 60: 1550, 70: 1750, 75: 2000, 80: 2400,
    87: 3500, 90: 4200, 94: 6000, 95: 6500, 97: 10000, 99: 13000
  },

  // PARANÁ - R$ 1000=7%, R$ 2000=41%, R$ 3500=72%, R$ 6000=88%, R$ 10000=95%
  "PR": {
    5: 800, 7: 1000, 10: 1200, 20: 1550, 30: 1800,
    40: 1950, 41: 2000, 50: 2200, 60: 2500, 70: 2900,
    72: 3500, 80: 4300, 88: 6000, 90: 7000, 95: 10000, 99: 15000
  },

  // PERNAMBUCO - R$ 1000=26%, R$ 2000=69%, R$ 3500=83%, R$ 6000=93%, R$ 10000=97%
  "PE": {
    5: 500, 10: 700, 20: 850, 26: 1000, 30: 1100,
    40: 1300, 50: 1500, 60: 1700, 69: 2000, 70: 2050,
    80: 2700, 83: 3500, 90: 4800, 93: 6000, 95: 7500, 97: 10000, 99: 14000
  },

  // PIAUÍ - R$ 1000=34%, R$ 2000=72%, R$ 3500=85%, R$ 6000=94%, R$ 10000=97%
  "PI": {
    5: 400, 10: 600, 20: 750, 30: 900, 34: 1000,
    40: 1100, 50: 1300, 60: 1550, 70: 1800, 72: 2000,
    80: 2500, 85: 3500, 90: 4500, 94: 6000, 95: 6500, 97: 10000, 99: 13000
  },

  // RIO DE JANEIRO - R$ 1000=11%, R$ 2000=46%, R$ 3500=72%, R$ 6000=86%, R$ 10000=93%
  "RJ": {
    5: 650, 10: 950, 11: 1000, 20: 1300, 30: 1600,
    40: 1800, 46: 2000, 50: 2150, 60: 2500, 70: 3000,
    72: 3500, 80: 4500, 86: 6000, 90: 7500, 93: 10000, 95: 12000, 99: 18000
  },

  // RIO GRANDE DO NORTE - R$ 1000=25%, R$ 2000=68%, R$ 3500=82%, R$ 6000=93%, R$ 10000=96%
  "RN": {
    5: 550, 10: 750, 20: 900, 25: 1000, 30: 1100,
    40: 1300, 50: 1500, 60: 1700, 68: 2000, 70: 2100,
    80: 2700, 82: 3500, 90: 4800, 93: 6000, 95: 7500, 96: 10000, 99: 13000
  },

  // RIO GRANDE DO SUL - R$ 1000=9%, R$ 2000=43%, R$ 3500=72%, R$ 6000=88%, R$ 10000=95%
  "RS": {
    5: 700, 9: 1000, 10: 1100, 20: 1450, 30: 1750,
    40: 1950, 43: 2000, 50: 2200, 60: 2550, 70: 3000,
    72: 3500, 80: 4400, 88: 6000, 90: 6800, 95: 10000, 99: 16000
  },

  // RONDÔNIA - R$ 1000=13%, R$ 2000=53%, R$ 3500=78%, R$ 6000=92%, R$ 10000=97%
  "RO": {
    5: 650, 10: 850, 13: 1000, 20: 1200, 30: 1400,
    40: 1600, 50: 1850, 53: 2000, 60: 2150, 70: 2500,
    78: 3500, 80: 3700, 90: 5500, 92: 6000, 95: 8000, 97: 10000, 99: 14000
  },

  // RORAIMA - R$ 1000=15%, R$ 2000=60%, R$ 3500=78%, R$ 6000=91%, R$ 10000=96%
  "RR": {
    5: 600, 10: 800, 15: 1000, 20: 1150, 30: 1350,
    40: 1550, 50: 1750, 60: 2000, 70: 2400, 78: 3500,
    80: 3700, 90: 5400, 91: 6000, 95: 8000, 96: 10000, 99: 13000
  },

  // SANTA CATARINA - R$ 1000=4%, R$ 2000=31%, R$ 3500=67%, R$ 6000=88%, R$ 10000=95%
  "SC": {
    4: 1000, 5: 1050, 10: 1300, 20: 1700, 31: 2000,
    40: 2300, 50: 2600, 60: 2900, 67: 3500, 70: 3700,
    80: 4700, 88: 6000, 90: 6800, 95: 10000, 99: 16000
  },

  // SÃO PAULO - R$ 1000=7%, R$ 2000=42%, R$ 3500=70%, R$ 6000=87%, R$ 10000=94%
  "SP": {
    5: 800, 7: 1000, 10: 1200, 20: 1600, 30: 1850,
    40: 2050, 42: 2000, 50: 2300, 60: 2700, 70: 3500,
    80: 4600, 87: 6000, 90: 7500, 94: 10000, 95: 11000, 99: 18000
  },

  // SERGIPE - R$ 1000=25%, R$ 2000=71%, R$ 3500=84%, R$ 6000=93%, R$ 10000=97%
  "SE": {
    5: 500, 10: 700, 20: 850, 25: 1000, 30: 1100,
    40: 1300, 50: 1500, 60: 1700, 71: 2000, 80: 2600,
    84: 3500, 90: 4500, 93: 6000, 95: 7000, 97: 10000, 99: 13000
  },

  // TOCANTINS - R$ 1000=14%, R$ 2000=57%, R$ 3500=79%, R$ 6000=92%, R$ 10000=97%
  "TO": {
    5: 650, 10: 850, 14: 1000, 20: 1200, 30: 1400,
    40: 1600, 50: 1800, 57: 2000, 60: 2100, 70: 2400,
    79: 3500, 80: 3600, 90: 5200, 92: 6000, 95: 7500, 97: 10000, 99: 13000
  }
} as const;

// Função para obter distribuição de qualquer estado
export const obterDistribuicaoEstado = (estado: string) => {
  return DISTRIBUICAO_POR_ESTADO[estado as keyof typeof DISTRIBUICAO_POR_ESTADO] || {
    10: 600, 20: 1100, 30: 1400, 40: 1600, 50: 1800,
    60: 2000, 70: 2400, 80: 3000, 90: 4800, 95: 7200, 99: 10500
  };
};

// Ícones para as profissões
export const ICONES_PROFISSOES = {
  medico: "👨‍⚕️",
  enfermeiro: "👩‍⚕️", 
  professor: "👨‍🏫"
} as const;